<template>
    <img id="logo" src="@/assets/img/ui/logo.png" @click="navigateToHomePage">
</template>
<script>
export default {
    name: "Logo",
    data() {
        return {
            
        }
    },
    methods: {
        navigateToHomePage() {
            this.$emit('closeNavigation')
            let navigateTo = app.manifest.data.custom.find(c => c.type === "customLogoNavigation").data.logoNavigatesTo;
            app.manifest.navigateToRoute(app.manifest.getRouteFromID(navigateTo))
        }
    }
}
</script>
<style lang="scss" scoped>
    @import '@/assets/sass/_responsiveness.scss';

    #logo {
        z-index: 2;
        cursor: pointer;

        @include tablet-down {
            height: 23px
        }

        @include mobile-only {
            height: 18px
        }
    }
</style>